import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Tabs, TabsList, TabsTrigger } from '@/ui/primitives';
import { PageShell } from '@/ui/layout';
import { OportunidadesReport } from '@/modules/crm/components/CrmRelatoriosTab';

export const Route = createFileRoute('/_authed/crm_/relatorios_/oportunidades')({
  component: CrmRelatoriosOportunidadesPage,
});

function CrmRelatoriosOportunidadesPage() {
  const navigate = useNavigate();
  return (
    <PageShell
      eyebrow="Comercial · Relatórios"
      title="Oportunidades"
      lead="Lista completa das oportunidades comerciais com filtros e gráficos."
    >
      <Tabs
        value="relatorios"
        onValueChange={(v) => {
          if (v === 'oportunidades') void navigate({ to: '/crm' });
        }}
      >
        <TabsList>
          <TabsTrigger value="oportunidades">Oportunidades</TabsTrigger>
          <TabsTrigger value="relatorios">Relatórios</TabsTrigger>
        </TabsList>
      </Tabs>
      <OportunidadesReport />
    </PageShell>
  );
}
